import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

const headerStyle = {
  color: "white",
  fontWeight: 600,
  fontSize: "14px",
  padding: "16px 20px",
  borderBottom: "2px solid #000080",
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: "#bb1ccc !important",
};

const cellStyle = {
  padding: "16px 20px",
  fontSize: "14px",
};

const DQSummaryTable = ({
  assets = [],
  finalResult = false,
  ruleSuggestionsLoading = false,
  ruleSuggestionsLoadingId = null,
  onFetchRuleSuggestions = () => {},
  onOpenConfig = () => {},
  onViewResult = () => {},
  getDQStatusPill = () => null,
  onRunDQAsset = () => {},
  runDqLoadingAssetId = null,
}) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        maxHeight: "500px",
        overflow: "auto",
      }}
    >
      <Table sx={{ minWidth: 650 }} stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={headerStyle}>Asset Name</TableCell>
            <TableCell sx={headerStyle}>Recommended Rules</TableCell>
            <TableCell sx={headerStyle}>Configuration</TableCell>
            <TableCell sx={headerStyle}>DQ Job Status</TableCell>
            <TableCell sx={headerStyle}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(assets || []).map((row, index) => {
            const status = row.dq_job_status;
            const isRunning = runDqLoadingAssetId === row.id;
            const isNotStarted = !status || status === "Not Started";
            const isSuccess = status === "Success" || status === "Completed";

            return (
              <TableRow
                key={row.id || row.name || index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                  "&:hover": {
                    backgroundColor: "#f0f8ff",
                    transition: "background-color 0.2s ease",
                  },
                }}
              >
                {/* Asset Name */}
                <TableCell sx={{ ...cellStyle, fontWeight: 600, color: "#2c3e50" }}>
                  {row.name}
                </TableCell>

                {/* Recommended Rules */}
                <TableCell sx={{ ...cellStyle, color: "#555" }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => onFetchRuleSuggestions(row.id)}
                    disabled={ruleSuggestionsLoading && ruleSuggestionsLoadingId === row.id}
                    sx={{
                      color: "#bb1ccc",
                      borderColor: "#bb1ccc",
                      fontWeight: 600,
                      "&:hover": { backgroundColor: "#f0f8ff", borderColor: "#bb1ccc" },
                      "&:disabled": { color: "#9ca3af", borderColor: "#9ca3af" },
                    }}
                  >
                    {ruleSuggestionsLoading && ruleSuggestionsLoadingId === row.id
                      ? "Loading..."
                      : "View Rules"}
                  </Button>
                </TableCell>

                {/* Configuration */}
                <TableCell sx={cellStyle}>
                  <IconButton
                    aria-label="settings"
                    onClick={() => onOpenConfig(row.id, row.name)}
                    sx={{ color: "#bb1ccc", "&:hover": { backgroundColor: "#f0f8ff" } }}
                  >
                    <SettingsIcon />
                  </IconButton>
                </TableCell>

                {/* DQ Job Status */}
                <TableCell sx={cellStyle}>
                  {getDQStatusPill(status)}
                </TableCell>

                {/* Action */}
                <TableCell sx={cellStyle}>
                  {isNotStarted ? (
                    <Button
                      variant="contained"
                      size="small"
                      disabled={isRunning}
                      onClick={() => onRunDQAsset(row.id)}
                      sx={{
                        backgroundColor: isRunning ? "#9ca3af" : "#bb1ccc",
                        color: "#fff",
                        fontWeight: 600,
                        textTransform: "none",
                        "&:hover": { backgroundColor: "#000080" },
                        "&:disabled": { backgroundColor: "#9ca3af", color: "#fff" },
                      }}
                    >
                      {isRunning ? "Starting..." : "Run DQ Check"}
                    </Button>
                  ) : (isSuccess || status === "Failed") && finalResult ? (
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => onViewResult(row.id)}
                      sx={{
                        color: "#bb1ccc",
                        borderColor: "#bb1ccc",
                        fontWeight: 600,
                        textTransform: "none",
                        "&:hover": { backgroundColor: "#f0f8ff", borderColor: "#bb1ccc" },
                      }}
                    >
                      View Result
                    </Button>
                  ) : status === "In Progress" ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: "#f57c00",
                          animation: "pulse 1.5s infinite",
                          "@keyframes pulse": {
                            "0%, 100%": { opacity: 1 },
                            "50%": { opacity: 0.3 },
                          },
                        }}
                      />
                      <span style={{ fontSize: "13px", fontWeight: 600, color: "#f57c00" }}>
                        In Progress
                      </span>
                    </Box>
                  ) : null}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DQSummaryTable;

